let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eoaaa")).then(() => parcelRequire('J31PF'));